var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#212121;}\r\n\t.st1{fill:#717171;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32,
    cy: 32,
    r: 31.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.3,19.2c-0.1-0.4-0.3-0.4-0.5-0.5c-0.5-0.2-1.3,0.1-1.3,0.1S16.1,29.3,14.4,30.5c-0.4,0.3-0.5,0.4-0.5,0.6 c-0.3,0.8,0.6,1.2,0.6,1.2l7.6,2.5c0,0,0.3,0,0.4,0c1.7-1.1,17.4-11,18.3-11.3c0.1,0,0.2,0,0.2,0.1C40.6,24.8,27,36.9,27,36.9 S26.9,37,26.9,37l0,0l-0.7,7.5c0,0-0.3,2.3,2,0c1.6-1.6,3.2-3,4-3.7c2.6,1.8,5.4,3.8,6.6,4.8c0.6,0.5,1.1,0.6,1.5,0.6 c1.2,0,1.5-1.3,1.5-1.3s5.4-21.6,5.5-24.5c0-0.3,0-0.5,0-0.7C47.4,19.6,47.4,19.3,47.3,19.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.da39dd42ccf560536aefda53821386ea.svg";
export { ForwardRef as ReactComponent };